import { render } from "./List.vue?vue&type=template&id=57fc92a4"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=57fc92a4&lang=less"

import exportComponent from "/codebuild/output/src3271881597/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__